/* global axios */
import ApiClient from './ApiClient';

class ConversationFlowExecutionsAPI extends ApiClient {
  constructor() {
    super('conversations', {
      accountScoped: true,
    });
  }

  getUrl(conversationId) {
    return `${this.url}/${conversationId}/flow_executions`;
  }

  get(conversationId, params = {}) {
    return axios.get(this.getUrl(conversationId), { params });
  }

  show(conversationId, executionId) {
    return axios.get(`${this.getUrl(conversationId)}/${executionId}`);
  }
}

export default new ConversationFlowExecutionsAPI();
